import React, { useEffect, useState } from 'react';
import styles from './MassDownload.module.scss';
import { Button, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { attachmentsActions } from '../../../actions/attachments.actions';

export const MassDownload = () => {
  const selectedDocuments = useSelector(
    (store) => store.documentListStore.selectedDocuments
  );
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    const fetchAttachments = async () => {
      if (selectedDocuments.length) {
        const fetchedAttachments = await Promise.all(
          selectedDocuments.map((docId) =>
            attachmentsActions.fetchAttachments(docId, 'documents')
          )
        );

        const allAttachments = fetchedAttachments.reduce((acc, attachments) => {
          return acc.concat(attachments.data);
        }, []);

        setAttachments(allAttachments);
      }
    };

    fetchAttachments().catch((error) => {
      console.error('Error fetching attachments:', error);
    });
  }, [selectedDocuments]);

  useEffect(() => {
    console.log(attachments, 'attachments');
  }, [attachments]);

  if (!attachments.length || !selectedDocuments.length) return null;

  const handleDownload = (docs) => {
    docs.forEach((doc) => {
      attachmentsActions.fetchAttachment(
        doc.docId,
        doc.fileName,
        doc.name,
        'documents'
      );
    });
  };

  return (
    <Tooltip
      title={`Скачать документы (${selectedDocuments.length})`}
      placement="bottom"
    >
      <Button
        type="primary"
        className={styles.root}
        onClick={() => handleDownload(attachments)}
        shape="circle"
        icon="download"
      />
    </Tooltip>
  );
};
